import { doesWorkflowRejectCodeExist } from '@tassat/common-definitions';
import { IFormValues } from '@tassat/forms/src/WithdrawalWalletMappingForm/types';

import Worker from 'Lib/worker/PrimusWorkerWrapper';

export const submitWithdrawalWalletMappingForm = async (values: IFormValues, opts: {
    accountWithdrawalDataId: string;
    setSubmitError: React.Dispatch<React.SetStateAction<string>>;
    onClose: () => void;
}): Promise<void> => {
    const {
        accountWithdrawalDataId,
        setSubmitError,
        onClose
    } = opts;

    const errors = [];
    try {
        values.Mappings.forEach(async (mapping) => {
            const response = await Worker.getInstance()
                .createAccountWithdrawalRelationship({
                    AccountId: mapping.Wallet.value,
                    AccountWithdrawalDataId: accountWithdrawalDataId
                });

            if (response.data && response.data.Status === 49 || doesWorkflowRejectCodeExist(response.data.Status)) {
                errors.push(mapping.Wallet.label);
            }
        });

        if (errors.length > 0) {
            setSubmitError(`Could not map withdrawal instruction to account(s): ${errors.join(', ')}`);
        } else {
            onClose();
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};